/**
 * KpiIcon — renders the icon for a dashboard KPI key.
 *
 * `kpiVisual()` returns the icon as a COMPONENT (so its module can stay a `.ts`
 * file), and the dashboards render their KPIs from inside `.map()` callbacks
 * with implicit returns. This thin wrapper lets them stay that way:
 *
 *   <KpiCard icon={<KpiIcon kpiKey={key} />} tone={kpiVisual(key).tone} … />
 */
import { kpiVisual } from './kpiVisuals';

export interface KpiIconProps {
  /** DTO field name for the KPI, e.g. `toArrive`. */
  kpiKey: string;
}

export default function KpiIcon({ kpiKey }: KpiIconProps) {
  const { Icon } = kpiVisual(kpiKey);
  return <Icon />;
}
